import type { PenShape as PenShapeType } from '@/features/comment-on-file';
import { smoothedPath } from '../utils/smoothedPath';
import { strokeWidthFor } from './strokeWidths';

interface Props {
  shape: PenShapeType;
  color: string;
  focused?: boolean;
  halo?: boolean;
}

export function PenShape({ shape, color, focused, halo }: Props) {
  if (shape.points.length === 0) return null;
  const d = smoothedPath(shape.points);
  const strokeWidth = strokeWidthFor('pen', { focused, halo });
  return (
    <path
      d={d}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
  );
}
